import { createContext } from '@lit/context';
import { LearningJourneysClient } from '../clients/learning-journeys-client';

export const learningJourneysClientContext = createContext<LearningJourneysClient>(Symbol('learning-journeys-client'));
